<template>
  <v-btn
    block
    outlined
    :color="disabled ? 'grey': 'primary'"
    :class="{ 'primary-gradient': !disabled, 'px-0': disabled }"
    @click="goToSummary()"
    :disabled="disabled"
    :large="showDisplayCurrency && !!total"
  >
    <v-layout row px-5 align-center>
      <v-icon dark color="primary">shopping_cart</v-icon>
      <amount-badge :amount="quantity" persistent class="mx-2" theme-color="secondary" />
      <span v-if="total" class="d-flex flex-column align-start" :class="{ 'py-1': showDisplayCurrency }">
        {{ getPriceString({ amount: total, currency: currency }) }}
        <span v-if="showDisplayCurrency" class="grey--text">
          {{ getPriceString({ amount: total, currency: currency, displayCurrency: displayCurrency }) }}
        </span>
      </span>
      <v-spacer />
      <span v-if="!compact">{{ text || $t("catalog.view_order") }}</span>
    </v-layout>
  </v-btn>
</template>

<script>
import moneyMixins from '@/mixins/MoneyFormat'
import { mapGetters } from 'vuex'
import router from '@/router'
export default {
  mixins: [moneyMixins],
  props: {
    compact: Boolean,
    goToRoute: String,
    quantity: Number,
    total: Number,
    currency: Object,
    disabled: Boolean,
    text: String,
  },
  methods: {
    goToSummary () {
      if (this.goToRoute) {
        router.push({
          name: this.goToRoute,
        })
      } else {
        this.$emit('click')
      }
    },
  },
  computed: {
    ...mapGetters('me', ['getPriceString', 'showDisplayCurrency', 'displayCurrency']),
  },
  components: {
    AmountBadge: () => import('@/components/view-components/catalog/AmountBadge.vue'),
  },
}
</script>